import { BaseClass } from '@components/BaseClass.js';
export class ConnectivityManager extends BaseClass {
    constructor() {
        super(...arguments);
        this.componentName = 'ConnectivityManager';
        this._isOnline = true;
    }
    get isOnline() { return this._isOnline; }
    set isOnline(b) {
        if (this._isOnline === b) {
            return;
        }
        this._propertySet('isOnline', b);
    }
    init() {
        super.init();
        this.isOnline = (typeof navigator !== 'undefined' ? navigator.onLine : true);
        this.initWeb();
    }
    isOnline$() {
        return this.propertyGet$('isOnline');
    }
    initWeb() {
        this._boundOnline = () => (this.isOnline = true);
        this._boundOffline = () => (this.isOnline = false);
        window.addEventListener('online', this._boundOnline);
        window.addEventListener('offline', this._boundOffline);
    }
    destroy() {
        super.destroy();
        if (this._boundOnline) {
            window.removeEventListener('online', this._boundOnline);
            this._boundOnline = undefined;
        }
        if (this._boundOffline) {
            window.removeEventListener('offline', this._boundOffline);
            this._boundOffline = undefined;
        }
    }
}
ConnectivityManager.VERSION = '$Revision: 1 $';
